import React from "react";
import EditMetaData from "./EditMetaData";
import InsertContentsPagePDF from "./InsertContentsPagePDF";
import {changePage} from "../action/books";
import {connect} from "react-redux";
import axios from "axios";

class EditBook extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {currentPageNo: props.currentPageNo};
      axios.defaults.headers.common['bookId'] = props.match.params.bookId;
    };
    changePage1 = () => {
        this.props.changePage({currentPageNo: 1});
        this.setState({currentPageNo: 1});
    };
    changePage2 = () => {
        this.props.changePage({currentPageNo: 2});
        this.setState({currentPageNo: 2});
    };
    render(){
        const {currentPageNo} = this.state;
        const {changePage1, changePage2} = this;
        return(
            <div>
                {!this.props.books &&
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                }
                <div className="editBookTab">
                   <h1 className={currentPageNo === 1 && "active"} onClick={changePage1}>Edit Book Meta Data</h1>
                   <h1 className={currentPageNo === 2 && "active"} onClick={changePage2}>Edit Contents of PDF</h1>
                </div>  
                {this.state.currentPageNo === 1 && (
                    <EditMetaData changePage={this.changePage} bookId={this.props.match.params.bookId}/>
                )}
                {this.state.currentPageNo === 2 && (
                    <InsertContentsPagePDF bookId={this.props.match.params.bookId} changePage={this.changePage}/>
                )}
            </div>
        );
    };
};

function mapStateToProps (state) {
    return {currentPageNo: state.EditBookForm.currentPageNo, books: state.AllBooks.books}
}

export default connect(mapStateToProps, {changePage})(EditBook);